import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { gsap } from "gsap";
import { Maths } from '../_app/cuchillo/utils/Maths';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { GetBy } from '../_app/cuchillo/core/Element';
// import BezierEasing from 'bezier-easing';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { isSmartphone } from '../_app/cuchillo/core/Basics';
// import { Metrics } from '../_app/cuchillo/core/Metrics';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';


class ScrollItem__BlockNews extends ScrollItem__BlockDefault {
    _call;
    _slider;
    _yOld = 0;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        if (!GetBy.class('__holder', __link)[0]) return;

        this.container = __link;
        this.holder = GetBy.class('__holder', this.container)[0];
        this._slider = new InfiniteScroll(InfiniteScroll.AXIS_X, {
            domResize: this.container,
            appendContainer: this.holder,
            container: this.holder,
            multiplicator: 2,
            minSpeed: 0,
            inverted: false,
            gap: 0,
            itemClass: ScrollItem__BlockNews__Item,
            hasVirtuaScroll: false,
            hasInteraction: true
        });

        this._call = () => this.loop();
        this.onShow = () => {
            this._slider.show();
            this._slider.enabled = true;
            gsap.ticker.add(this._call);
        };

        this.onHide = () => {
            this._slider.enabled = false;
            gsap.ticker.remove(this._call);
        };
    }

    resize(w, h) {
        super.resize(w, h);
        if (this._slider) this._slider.resize();
    }

    loop() {
        if (this._slider) {
            // this._slider.check({deltaY:-(this.y - this._yOld)});
            // this._yOld = this.y;
            this._slider.loop();
        }
    }

    dispose() {
        if (this._slider) this._slider.dispose();
        super.dispose();
    }
}

class ScrollItem__BlockNews__Item extends InfiniteScroll__Item {
    _card;
    _limits = {}
    hasMove = false;

    constructor(__d, __i, __axis = InfiniteScroll.AXIS_Y) {
        super(__d, __i, __axis, false);

        this._card = GetBy.selector('.card', __d)[0];
        this._tapa = GetBy.selector('.tapa', __d)[0];


        // this.isInfoShow = false;
        // this.setupLimits();
        // this.resetHook();
    }

    drawHook() {
        if (!this._card) return;

        this.move();
    }

    resetHook() {
        if (!this._card) return;


    }

    showInfo() {
        if (this.isInfoShow) return;
        this.isInfoShow = true;

    }

    hideInfo() {
        if (!this.isInfoShow) return;
        this.isInfoShow = false;

    }

    move() {

        //const progress = Maths.normalize(-1, 1, this.progressInside);
        const rotation = 85;



        let p = 0;
        let x = 0;
        let y = 0;
        let z = 0;
        let opacity = 1;

        if (this.progressInside < .5) {
            p = Maths.normalize(-.5, .5, this.progressInside);


            x = 10 * p;
            y = -10 * p;
            z = -p;

            this._tapa.style.opacity = p * .01;

        } else {
            p = Maths.normalize(1.5, .5, this.progressInside);


            x = -10 * p;
            y = 110 * p;
            opacity = 4 - p * 3;

            this._tapa.style.opacity = 0;
        }


        this._card.style[CSS.transform] = CSS.translate3D(x, y, z);
        this._card.style.opacity = opacity;


        //Z
        if (isSmartphone) {
            const z = 400 - Math.abs(this.progressInside * 100);
            this._z = z;
            this.dom.style.zIndex = String(Math.max(0, Math.round(z)));
        } else {
            const z = -Math.abs(this.progressInside * 100);
            this._z = z;
            this.dom.style.zIndex = String(Math.round(z));
        }

        return;

        if (progress < .06 && progress > -.06) {
            this.showInfo();
        } else {
            this.hideInfo();
        }

        //SCALE
        // let scale = Maths.lerp(.5, 1.01, (1 - Math.abs(progress)));
        // scale *= scale;



        return;
        this._card.style[CSS.transform] =
            CSS.rotate3D(0, 0, 1, rotation * progress);/* + " " 
            + CSS.scale3D(scale, scale, scale);*/

        // this._figure.style[CSS.transform] = CSS.scale3D(scale, scale, scale);
    }



    dispose() {
        super.dispose();
    }
}

Scroll._registerClass('BlockNews', ScrollItem__BlockNews);